<template>
  <div class="px-2 py-4 bg-red-50 border-red-200 border rounded flex items-center justify-between w-full border-t-4 border-t-red-800">
    <div class="flex items-center">
        <font-awesome-icon :icon="faArchive" class="text-red-700 mx-3" />
      <div class="text-sm font-medium text-red-800">
        <slot />
      </div>
        <button class="text-sm font-medium ml-1 underline text-red-800" tabindex="-1" type="button" @click="$emit('restore')">Click here to Restore</button>
    </div>
  </div>
</template>

<script setup>
import Icon from '@/Shared/Icon.vue'
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import {faArchive} from "@fortawesome/pro-solid-svg-icons";


</script>
